import * as yup from 'yup';
import {
  REPLY_MAX_LENGTH,
  REVIEW_TITLE_MAX_LENGTH,
} from '~/lib/discussions/constants';

export const YupReplySchema = yup.object().shape({
  comment: yup.string().max(REPLY_MAX_LENGTH).required(),
  notify: yup.boolean(),
});

export const YupQuestionSchema = yup.object().shape({
  comment: yup.string().required(),
  notify: yup.boolean(),
});

export const YupReviewSchema = yup.object().shape({
  title: yup.string().required(),
  rating: yup.number().min(1).max(5).required(),
  comment: yup.string().required(),
  notify: yup.boolean(),
});

export const YupLeaveReviewSchema = yup.object().shape({
  title: yup.string().required().max(REVIEW_TITLE_MAX_LENGTH),
  rating: yup.number().min(1).max(5).required(),
  comment: yup.string().required().max(REPLY_MAX_LENGTH),
});

export interface QuestionSchema
  extends yup.InferType<typeof YupQuestionSchema> {
  title?: never;
  rating?: never;
}

export interface ReviewSchema extends yup.InferType<typeof YupReviewSchema> {}

export type QuestionOrReviewSchema = QuestionSchema | ReviewSchema;

export type ReviewStatsResponse = {
  needs_reply: number;
  needs_moderation: number;
  review_details: {
    review_count: number;
    average_rating: string;
    would_recommend: number;
    review_count_1_tacos: number;
    review_count_2_tacos: number;
    review_count_3_tacos: number;
    review_count_4_tacos: number;
    review_count_5_tacos: number;
  };
};
